import { render, staticRenderFns } from "./CsrfWhitelistSetting.vue?vue&type=template&id=74163d54&"
import script from "./CsrfWhitelistSetting.vue?vue&type=script&lang=ts&"
export * from "./CsrfWhitelistSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports